import React from "react";

import {
  getNorthbeamUtmPlatformParams,
  NorthbeamUtmPlatform,
} from "@features/utm-guide";
import grin from "@features/utm-guide/images/grin.png";

export function Grin() {
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform: NorthbeamUtmPlatform.GRIN,
  });
  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        For each of the following parameter pairs, input them into <b>Grin</b>{" "}
        during the <b>URL details</b> step of creating an Ad.
      </p>
      <img className="img-fluid mb-3" src={grin} alt="" />
      <table className="table table-bordered table-striped table-sm bg-white">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {urlParamPairs.map(({ key, value }) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
